<ol>
  <li>
    Zapoznałem/am się z klauzulą informacyjną RODO: <strong>{{ application?.clause ? 'Tak' : 'Nie' }}</strong>
  </li>
</ol>
